import React from 'react';
import {FormControl, InputLabel, ListItemText, MenuItem, Select} from '@material-ui/core';
import {vcaTypes} from '../src/components/helpers/tools';

export const tableConfig = {
  NETWORK: {
    headerConfig: {
      '&:nth-child(1)': {
        width: '5%',
      },
      '&:nth-child(2)': {
        width: '20%',
      },
      '&:nth-child(3)': {
        width: '20%',
      },
      '&:nth-child(4)': {
        width: '20%',
      },
      '&:nth-child(5)': {
        width: '20%',
      },
      '&:nth-child(6)': {
        width: '5%',
      },
      '&:nth-child(7)': {
        width: '30%',
      },
    },
    columns: [
      {
        label: 'Display Name',
        name: 'displayName',
        options: {
          viewColumns: false,
        },
      },
      {
        label: 'Name',
        name: 'name',
        options: {
          viewColumns: false,
        },
      },
      {
        label: 'Description',
        name: 'description',
        options: {
          display: 'false',
          filter: false,
        },
      },
      {
        label: 'Tags',
        name: 'tags',
        options: {
          viewColumns: false,
        },
      },
      {
        label: 'VCA Provider IDs',
        name: 'providerIDs',
        options: {
          display: 'false',
          filter: false,
        },
      },
      {
        label: 'VCA Status',
        name: 'providers',
        options: {
          filter: true,
          viewColumns: false,
          filterType: 'custom',
          customFilterListOptions: {
            render: v => `VCA: ${v}`,
          },
          filterOptions: {
            logic: (location, filters) => {
              if (filters.length) {
                const selectedFilter = filters[0].toLowerCase();
                const vcaTags = location.toLowerCase().split('::');
                for (const tag of vcaTags) {
                  if (tag.toLowerCase() === 'no vca defined') return selectedFilter !== 'no vca defined';

                  const type = tag
                    .split('-')[1]
                    .trim()
                    .toLowerCase();

                  if (type.includes(selectedFilter)) return false;
                }
                return true;
              }
              return false;
            },
            display: (filterList, onChange, index, column) => (
              <FormControl>
                <InputLabel htmlFor="vca-providers-select">VCA Providers</InputLabel>
                <Select
                  id="vca-providers-select"
                  renderValue={selected => selected}
                  value={filterList[index].length > 0 ? filterList[index] : 'All'}
                  onChange={event => {
                    const newFilters = event.target.value !== 'all' ? [event.target.value] : [];
                    onChange(newFilters, index, column);
                  }}
                >
                  <MenuItem value="all">
                    <ListItemText primary="All" />
                  </MenuItem>

                  {vcaTypes.map(item => (
                    <MenuItem key={item} value={item}>
                      <ListItemText primary={item} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ),
          },
        },
      },
      {
        label: 'Upsell',
        name: 'offerToNonSubscribers',
        options: {
          viewColumns: false,
          filterType: 'dropdown',
        },
      },
      {
        label: 'Images',
        name: 'images',
        options: {
          display: 'true',
          filter: false,
          viewColumns: false,
        },
      },
    ],
  },
  ASSET: {
    headerConfig: {
      '&:nth-child(2)': {
        width: '20%',
      },
      '&:nth-child(3)': {
        width: '80%',
      },
    },
    columns: [
      {
        label: 'Echostar ID',
        name: 'echostarId',
        options: {
          viewColumns: false,
        },
      },
      {
        label: 'Name',
        name: 'name',
        options: {
          viewColumns: false,
        },
      },
      {
        label: 'RUID',
        name: 'ruid',
        options: {
          viewColumns: false,
          display: false,
        },
      },
      {
        label: 'Farallon GUID',
        name: 'farallonGuid',
        options: {
          viewColumns: false,
          display: false,
        },
      },
    ],
  },
  ALIASES: {
    headerConfig: {
      '&:nth-child(0)': {
        width: '5%',
      },
      '&:nth-child(1)': {
        width: '95%',
      },
    },
    columns: [
      {
        label: 'Alias ID',
        name: 'aliasID',
        options: {
          viewColumns: false,
          sort: true,
        },
      },
      {
        label: 'Alias Name',
        name: 'aliasName',
        options: {
          viewColumns: false,
          sort: true,
        },
      },
    ],
  },
  DATA_PACKAGE: {
    headerConfig: {
      '&:nth-child(1)': {
        width: '20%',
      },
      '&:nth-child(2)': {
        width: '15%',
      },
      '&:nth-child(3)': {
        width: '45%',
      },
      '&:nth-child(4)': {
        width: '25%',
      },
    },
    columns: [
      {
        label: 'RUID',
        name: 'dataPackageId',
        options: {
          viewColumns: false,
        },
      },
      {
        label: 'EST',
        name: 'est',
        options: {
          viewColumns: false,
        },
      },
      {
        label: 'Network',
        name: 'networkName',
        options: {
          viewColumns: false,
        },
      },
      {
        label: 'Resolution',
        name: 'resolution',
        options: {
          viewColumns: false,
        },
      },
    ],
  },
};
